/**
 * Attach human-facing question numbers.
 * Sectioned: 1.1, 1.2, 2.1 …
 * Flat (no sections / single untitled step): 1, 2, 3 …
 */
export function isFlatSurvey(steps = []) {
  if (!Array.isArray(steps) || steps.length === 0) return false;
  if (steps.length === 1 && (steps[0].is_flat || !String(steps[0].title || "").trim())) {
    return true;
  }
  return false;
}

export function withDisplayNumbers(steps = []) {
  const flat = isFlatSurvey(steps);
  let flatIndex = 0;
  return (steps || []).map((step, stepIndex) => {
    const questions = (step.questions || []).map((q, qi) => {
      flatIndex += 1;
      const display_number = flat ? String(flatIndex) : `${stepIndex + 1}.${qi + 1}`;
      return { ...q, display_number };
    });
    return { ...step, questions };
  });
}

export function displayNumberFor(steps, stepIndex, questionIndex) {
  if (isFlatSurvey(steps)) {
    let n = 0;
    for (let i = 0; i < steps.length; i++) {
      const qs = steps[i].questions || [];
      for (let j = 0; j < qs.length; j++) {
        n += 1;
        if (i === stepIndex && j === questionIndex) return String(n);
      }
    }
    return String(n);
  }
  return `${stepIndex + 1}.${questionIndex + 1}`;
}
